import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { getPackageDeals } from "api/PackageDeals";
import PackageDealCard from "components/packageDealCard";
import useApi from "hooks/useApi";
import { useTranslation } from "i18n";
import { CurrencyContext } from "pages/useContext";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./style.css";

function PackageDealsPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { currency } = useContext(CurrencyContext);
  const packageDealsApi = useApi(getPackageDeals);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    packageDealsApi.request(currency);
  }, [currency?.currency]);

  const deals = packageDealsApi.data?.deals || [];

  return (
    <div className="package-deals-page">
      <div className="container my-5 py-5">
        <header className="package-deals-page__header">
          <h1 className="package-deals-page__title">{t("packageDeals.title")}</h1>
          <p className="package-deals-page__subtitle">
            {t("packageDeals.pageSubtitle")}
          </p>
        </header>

        {packageDealsApi.loading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            py={10}
          >
            <CircularProgress
              sx={{ color: "var(--primary-color)" }}
              size={44}
            />
          </Box>
        ) : packageDealsApi.error ? (
          <div className="package-deals-page__error">
            <div className="package-deals-page__error-icon">⚠</div>
            <h2 className="package-deals-page__error-title">
              Something went wrong
            </h2>
            <p className="package-deals-page__error-message">
              The package tours could not be loaded. Please try again later or
              contact us.
            </p>
          </div>
        ) : deals.length === 0 ? (
          <div className="package-deals-page__empty">
            <div className="package-deals-page__empty-icon">✈</div>
            <h2 className="package-deals-page__empty-title">
              No offers at the moment
            </h2>
            <p className="package-deals-page__empty-message">
              New package tours coming soon. In the meantime, browse our flights
              and hotels.
            </p>
          </div>
        ) : (
          <div className="row package-deals-grid justify-content-start">
            {deals.map((deal) => (
              <div key={deal._id} className="col-md-6 col-lg-3 mb-4">
                <PackageDealCard
                  deal={deal}
                  currency={currency}
                  onClick={(d) => navigate(`/package-deals/${d?._id}`)}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default PackageDealsPage;
